export default "__VITE_ASSET__B4cSe3Kc__"